import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { mixins } from "../../styles"

const RequiredNoticeEl = styled.div`
  ${mixins.copy5}
  color: var(--color-neutral-dark);
  margin: 0 0 30px;
  padding: 20px 0;
`

const RequiredNotice = ({ className, children }) => {
  return <RequiredNoticeEl className={className}>{children}</RequiredNoticeEl>
}

RequiredNotice.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default RequiredNotice
